import React, { useEffect, useState } from 'react';
import { normalizeJudgeName } from '../utils/stringUtils';

const JudgeEditModal = ({ judge, onClose, onSave, isNew = false }) => {
  const [draft, setDraft] = useState(judge);

  useEffect(() => {
    setDraft({
      ...judge,
      score: judge.score ?? 0,
      dosyaSayisi: judge.dosyaSayisi ?? 0
    });
  }, [judge]);

  if (!judge || !draft) return null;

  const handleSave = () => {
    // İsmi normalize et: trim + tek boşluk + Türkçe büyük harf.
    // Manuel/eski hakim eşleştirmesi (Excel'den okunan satırlarla) için kritik.
    const normalizedName = normalizeJudgeName(draft.name);
    onSave({ ...draft, name: normalizedName });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-gray-900/50 px-4 py-10"
      role="dialog"
      aria-modal="true"
      aria-labelledby="judge-edit-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="relative w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-xl">
        <h3 id="judge-edit-title" className="mb-4 text-xl font-semibold text-gray-900">
          {isNew ? 'Yeni Hakim Ekle' : 'Hakim Bilgilerini Düzenle'}
        </h3>
        <div className="space-y-4">
          <div>
            <label htmlFor="judgeName" className="mb-1 block text-sm font-medium text-gray-700">
              Hakim Adı
            </label>
            <input
              id="judgeName"
              type="text"
              value={draft.name}
              onChange={(e) => setDraft({ ...draft, name: e.target.value })}
              className="w-full rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500"
              placeholder="Hakim adını giriniz"
            />
          </div>
          <div className="flex items-center">
            <input
              id="isAvailable"
              type="checkbox"
              checked={draft.isAvailableForAssignment}
              onChange={(e) => setDraft({ ...draft, isAvailableForAssignment: e.target.checked })}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <label htmlFor="isAvailable" className="ml-2 block text-sm text-gray-700">
              Tevziye Açık
              <span className="block text-xs text-gray-500">
                Hakimin yeni davalar için uygun olup olmadığını belirtir
              </span>
            </label>
          </div>
          <div className="flex items-center">
            <input
              id="isExperienced"
              type="checkbox"
              checked={draft.isExperienced}
              onChange={(e) => setDraft({ ...draft, isExperienced: e.target.checked })}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <label htmlFor="isExperienced" className="ml-2 block text-sm text-gray-700">
              Deneyimli Hakim
              <span className="block text-xs text-gray-500">
                Karmaşık davalar için yeterli deneyim
              </span>
            </label>
          </div>
          <div>
            <label htmlFor="assignmentRatio" className="mb-1 block text-sm font-medium text-gray-700">
              Tevzi Oranı
            </label>
            <select
              id="assignmentRatio"
              value={draft.assignmentRatio}
              onChange={(e) => setDraft({ ...draft, assignmentRatio: e.target.value })}
              className="w-full rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500"
            >
              <option value="1">Tam</option>
              <option value="3/4">3/4</option>
              <option value="2/3">2/3</option>
              <option value="1/2">1/2</option>
              <option value="1/3">1/3</option>
              <option value="1/4">1/4</option>
            </select>
            <p className="mt-1 text-xs text-gray-500">İş yükü dağılım oranı</p>
          </div>
          <div>
            <label htmlFor="score" className="mb-1 block text-sm font-medium text-gray-700">
              Puan
            </label>
            <input
              id="score"
              type="number"
              step="0.01"
              value={draft.score ?? 0}
              onChange={(e) => setDraft({ ...draft, score: parseFloat(e.target.value) || 0 })}
              className="w-full rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500"
              placeholder="Hakim puanı"
            />
            <p className="mt-1 text-xs text-gray-500">Güncel toplam / yük puanı</p>
          </div>
          <div>
            <label htmlFor="dosyaSayisi" className="mb-1 block text-sm font-medium text-gray-700">
              Dosya sayısı
            </label>
            <input
              id="dosyaSayisi"
              type="number"
              min="0"
              step="1"
              value={draft.dosyaSayisi ?? 0}
              onChange={(e) =>
                setDraft({ ...draft, dosyaSayisi: Math.max(0, Math.floor(parseFloat(e.target.value) || 0)) })
              }
              className="w-full rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500"
              placeholder="0"
            />
            <p className="mt-1 text-xs text-gray-500">
              Tevzi öncesi mevcut dosya adedi (algoritma adet dengesinde kullanılır)
            </p>
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            İptal
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow hover:bg-blue-700"
          >
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default JudgeEditModal;
